
export const BuiltInProperties = [
  'webinarTitle',
  'webinarDuration',
  'webinarId',
  'state',
  'sessionType',
  'id',
  'registeredTime',
  'sessionTime',
  'deviceTypeWhenRegistered',
  'moderatorName',
  'moderatorEmail',
  'webinarName',
  'attendeeId',
  'name',
  'teamId',
  'action',
  'notificationFromName',
  'firstName',
  'lastName',
  'domain',
  'email',
  'subscribed',
  'blocked',
  'timezone',
  'city',
  'country',
  'ip',
  'emailVerified',
  'firstRegistration',
  'latestSession',
  'registeredWebinars',
  'attendedWebinars',
  'attendanceRate',
  'averageWatched',
  'engagedWebinars',
  'engagementRate',
  'completedWebinars',
  'completionRate',
  'convertedWebinars',
  'conversionWebinars',
  'conversionRate',
  'attended',
  'joinedTime',
  'leftTime',
  'totalWatchedPercent',
  'watchedScheduledPercent',
  'watchedReplayPercent',
  'chatsSent',
  'actions',
  'likes',
  'message',
  'conversationId',
  'conversationLink',
  'completed',
  'converted',
  'purchaseAmount',
  'orderId',
  'deviceTypeWhenWatching',
  'tags',
  'firstOrigin',
  'firstReferrer',
  'gclid',
  'origin',
  'referrer',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
  'source',
  'registrationLink',
  'joinLink',
  'replayLink',
  'allWebinarsLink',
  'addToCalendarLink',
  'googleCalendarLink',
  'outlookComCalendarLink',
  'yahooCalendarLink',
  'messageId',
  'messageContent',
  'messageSentDate',
  'messageTo',
  'moderatorFirstName',
  'moderatorLastName',
  'messageType',
  'messageSentAtSecs',
  'conversationIsArchived',
  'sentByEmail',
  'sessionRecordLink',

];